import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { CompanyConfirmationAdmin } from './CompanyConfirmationAdmin'
import { useUser } from '~/@biz_account/useUser/useUser'

function CompanyConfirmationAdminContent() {
  const navigate = useNavigate()
  const { reloadUser } = useUser()

  useEffect(() => {
    const interval = setInterval(reloadUser, 3000)
    return () => clearInterval(interval)
  })

  return (
    <CompanyConfirmationAdmin
      onClose={() => {
        navigate('/')
      }}
    />
  )
}

export { CompanyConfirmationAdminContent }
